import * as Models from "../ts/rlAdmin.models";
import * as moment from "moment";
import { NotifyService } from "../services/notify-service";
import { EntityService } from "../services/entity-service";
import { LocalCacheService } from "../services/local-cache-service";
import * as Consts from "../ts/rlAdmin.consts";

export class BaseEntityController {

	entity: Models.IEntity;
	visibility: number;
	isDeletable: boolean = false;
	isValid: boolean;
	wasValidated: boolean;

	//Eyeball Preview
	selectedEntity: any;
	selectedEntityID: string;
	//--

	constructor(
		protected $scope: ng.IScope,
		protected $q: ng.IQService,
		protected entityService: EntityService,
        protected localCacheService: LocalCacheService,
        protected notifyService: NotifyService,
		protected $location?: ng.ILocationService,
		protected $anchorScroll?: ng.IAnchorScrollService) {

		this.isValid = false;
		this.wasValidated = false;
		this.visibility = 1;

		this.$scope.$on(Consts.Events.RefreshViewEntity, (e, data) => {			
				this.selectedEntityID = data;			
		});
	}

	Validate(): ng.IPromise<any> {

		if (this.entity == null) {
			console.debug("BaseEntityController.Validate() - no entity to validate (NULL)");
			return this.$q.resolve();
		}

		var entityID: string = this.entity.id;
		var cacheKey = `validate_${entityID}`;
		return this.localCacheService.getCachedOrDoCachePromise(cacheKey, () => this.entityService.validateEntity(entityID, this.visibility), moment.duration(5, 'seconds'))
			.then((results) => {
				this.isValid = results.isValid;
				this.wasValidated = true;
			});
	}

	ViewEntity(entityID: string) {
		if (!this.selectedEntity || this.selectedEntity.record.id != entityID) {
			this.selectedEntityID = entityID;
			this.entityService.getEntity(entityID)
                .then((res) => {
					this.selectedEntity = res;
				});
		} else {
			this.selectedEntityID = undefined;
			this.selectedEntity = undefined;
		}
	}

	ScrollTo(id: string) {
		var old = this.$location.hash();
		this.$location.hash(id);
		this.$anchorScroll();

		this.$location.hash(old);
	}
}
